"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = exports.HelperText = exports.Label = exports.InputContainer = void 0;
var core_1 = require("@material-ui/core");
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../typography");
exports.InputContainer = styled_components_1.default.div.withConfig({ displayName: "InputContainer", componentId: "sc-585ath" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["position:relative;"], [""])));
exports.Label = styled_components_1.default(typography_1.Typography.Sub2).attrs(function () { return ({ as: 'label' }); }).withConfig({ displayName: "Label", componentId: "sc-1tomifz" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["display:block;margin-bottom:", ";color:", ";"], ["", "", ""])), polished_1.rem(6), function (_a) {
    var theme = _a.theme;
    return theme.vui.colors.neutral.gray80;
});
exports.HelperText = styled_components_1.default(typography_1.Typography.Caption).withConfig({ displayName: "HelperText", componentId: "sc-q0dkoe" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["margin-top:", ";color:", ";"], ["", "", ""])), polished_1.rem(8), function (_a) {
    var theme = _a.theme, $error = _a.$error;
    return ($error ? theme.vui.colors.feedback.redError : theme.vui.colors.neutral.gray60);
});
exports.BaseInput = styled_components_1.default(core_1.OutlinedInput).withConfig({ displayName: "BaseInput", componentId: "sc-1mgne3c" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["&.MuiOutlinedInput-root{color:", ";background-color:", ";&.MuiOutlinedInput-multiline{padding:", " ", ";min-height:", ";}.MuiOutlinedInput-input{font-size:", ";line-height:1.3;box-sizing:border-box;}.MuiOutlinedInput-input:not(.MuiOutlinedInput-inputMultiline){padding:", " ", ";height:", ";&.MuiOutlinedInput-inputAdornedStart{padding-left:0;}&.MuiOutlinedInput-inputAdornedEnd{padding-right:0;}}.MuiOutlinedInput-notchedOutline{border-color:", ";border-width:", "px;}&.Mui-focused{color:", ";background-color:", ";.MuiOutlinedInput-notchedOutline{border-color:", ";border-width:", "px;}}&:hover:not(.Mui-focused){color:", ";background-color:", ";.MuiOutlinedInput-notchedOutline{border-color:", ";border-width:", "px;}}}"], ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""])), function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].default.textColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].default.backgroundColor;
}, polished_1.rem(13), polished_1.rem(16), polished_1.rem(56), polished_1.rem(16), polished_1.rem(13), polished_1.rem(16), polished_1.rem(56), function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].default.borderColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].default.borderWidth;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].focus.textColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].focus.backgroundColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].focus.borderColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].focus.borderWidth;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].hover.textColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].hover.backgroundColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].hover.borderColor;
}, function (_a) {
    var theme = _a.theme, $status = _a.$status;
    return theme.vui.component.input[$status].hover.borderWidth;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
